<template>
  <div id="app">
   <router-view/>

  </div>
</template>

<script>
import firebase from "firebase/app";
import 'firebase/app';
import 'firebase/auth';
import posed from 'vue-pose';
  import bgImg from '@/assets/icon.png'



export default {
  name: 'App',
   methods: {
    logOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace("/");
        });
    },
     zoomIn() {
    this.isZoomed = true;
  },
  zoomOut() {
    this.isZoomed = false;
  }
  },
  props: ['imageWidth', 'imageHeight', 'bgImg'],
  data: () => ({ isZoomed: false,
  fondo:bgImg,
   }),
  
  components: {
  ImageBoleta: posed.img({
  zoomedOut: {
    position: 'static',
    width: 'auto',
    height: 'auto',
    flip: true
  },
  zoomedIn: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    flip: true
  }
})
},
 
computed: {
  toggleZoom() {
    return this.isZoomed ? this.zoomOut : this.zoomIn;
  },
  pose() {
  return this.isZoomed ? 'zoomedIn' : 'zoomedOut';
}
},
 mounted() {
      firebase.auth().onAuthStateChanged(user =>  {
  if (user) {
    // User is signed in.
  } else {
    this.$router.replace("/").catch(()=>{});
    // No user is signed in.
  }
});
    }

}
</script>

<style>
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
  
}


@font-face {
  font-family: "Rachell";
  src: local("Rachell"),
   url(./fonts/RachelleStern.ttf) format("truetype");
}

.bg-company-red{
  background-color: orangered;
  font-weight: bolder;
  color: #ffffff;

  
}


.navbar-custom .b-nav-item {
color: rgba(255, 255, 255, 0.8);
font-weight: bolder;
}

.btn-color{
  font-weight: bolder;
    color: #ffffff;
    float:right;
    font-size: 15px;
}

.fromd-envia{
position: absolute;
top:10px;
right: 85px;
font-weight: bolder;
}


</style>

<!--
<div
  v-bind:style="{ width: '5px', height:'5px' }"
  v-on:click="toggleZoom"
>
   <ImageBoleta  :pose="pose" :src="fondo" />
</div> -->



// WEBPACK FOOTER //
// src/App.vue